import { getAuthenticatedTimeForGuacTerminal, setAuthenticatedTimeForGuacTerminal, getAuthenticatedTimeForGuacDesktop, setAuthenticatedTimeForGuacDesktop } from "@/utils/cookies";
export const getMinutesDiffFromNow = (time) => {
    let loginTimeStr = time || new Date(2019, 1, 1).toString();
    let loginTime = new Date(loginTimeStr);
    let minutes = Math.floor((Date.now() - loginTime.getTime()) / 1000 / 60);
    return minutes;
};
export const isGuacAuthenticatedForTerminal = () => {
    let minutes = getMinutesDiffFromNow(getAuthenticatedTimeForGuacTerminal());
    return minutes < 238;
};
export const isGuacAuthenticatedForDesktop = () => {
    let minutes = getMinutesDiffFromNow(getAuthenticatedTimeForGuacDesktop());
    return minutes < 238;
};
export const authenticateGuacTerminal = () => {
    window.open("https://shell.cyberlab.evolvesecurity.com:8443/guacamole", "_blank");
    setAuthenticatedTimeForGuacTerminal(new Date());
};
export const authenticateGuacDesktop = () => {
    window.open("https://desktop.cyberlab.evolvesecurity.com:8443/guacamole", "_blank");
    setAuthenticatedTimeForGuacDesktop(new Date());
};
//# sourceMappingURL=timeHelpers.js.map